// @flow

export const MAX_PIPELINE_NAME_LENGTH = 128
